// extracted by mini-css-extract-plugin
export default {"container":"DownloadFailed_container__8l5s8","innerContainer":"DownloadFailed_innerContainer__ojaB3","text":"DownloadFailed_text__XSvjQ"};